import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=7e59fba5&scoped=true"
import script from "./comment.vue?vue&type=script&lang=js"
export * from "./comment.vue?vue&type=script&lang=js"
import style0 from "./comment.vue?vue&type=style&index=0&id=7e59fba5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e59fba5",
  null
  
)

export default component.exports